import { render, staticRenderFns } from "./VideoWrap.vue?vue&type=template&id=c0efc7f6&"
import script from "./VideoWrap.vue?vue&type=script&lang=js&"
export * from "./VideoWrap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "VideoWrap.vue"
export default component.exports